import { Directive } from '@angular/core';


@Directive({ selector: 'select2-label' })
export class Select2Label {}
